import { useState, useEffect } from "react";
import axios from "../../axiosConfig";
import { PricesResponse } from "../../types/PricesTypes";

export const useGetPrices = (page: number = 1) => {
  const [data, setData] = useState<PricesResponse | null>(null);
  const [loading, setLoading] = useState<boolean>(false);

  const fetchPrices = async () => {
    try {
      setLoading(true);

      const response = await axios.get(`/prices?page=${page}`);
      setData(response.data);
    } catch (err: any) {
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchPrices();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page]);

  return { data, loading, refetch: fetchPrices };
};
